<template>
  <div
    class="o-grid__cell o-grid__cell--12 o-grid__cell--9-480 o-grid__cell--8-768 o-grid__cell--7-1024 o-grid__cell--6-1200 u-form-grid-nospace-y"
  >
    <div class="c-form-control-checkbox gev19__contexthelp">
      <input
        v-model="piniaStore.state.tarifinformationen.hugMitglied"
        id="tariffDiscountHuG"
        name="tariffDiscountHuG"
        type="checkbox"
        :value="true"
        data-parsley-multiple="tariffDiscountHuG"
        data-cy="hugMitglied"
        class="c-form-control-checkbox__input"
        tabindex="0"
        aria-label="Haus & Grund-Mitglied (10% Rabatt)"
        aria-describedby="tariffDiscountHuGInfo"
        role="checkbox"
      />
      <label class="c-form-control-checkbox__label" for="tariffDiscountHuG" style="max-width: 92%">
        <icon-sprite icon-name="icon-check-mark" css-klassen="c-form-control-checkbox__icon" :ist-klein="true" />
        <span class="c-form-control-checkbox__label-text">
          {{ isMakler ? "" : "Ja, ich bin " }}Haus &amp; Grund-Mitglied
          <strong>(10% Rabatt)</strong>
        </span>
      </label>
      <span
        role="button"
        aria-hidden="true"
        tabindex="-1"
        class="gev19__contexthelp-open"
        title="Hilfe anzeigen"
        @click="toggleSichtbarkeit('tariffDiscountHuG')"
      ></span>
      <infotext
        v-if="isMakler"
        name="tariffDiscountHuG"
        id="tariffDiscountHuGInfo"
        role="tooltip"
        text="Wir gewähren Ihrem Versicherungsnehmer bei Policierung des Antrages 10 % Rabatt, wenn dieser Mitglied in einem Haus & Grund Verein ist. Dieser Rabatt ist nicht kombinierbar mit weiteren Rabatten."
      />
      <Infotext
        v-else
        name="tariffDiscountHuG"
        id="tariffDiscountHuGInfo"
        role="tooltip"
        text="Haus &amp; Grund ist ein Eigentümerschutzbund, welcher Eigentümern
        verschiedene Dienstleistungen und Beratung rund um das Thema
        Eigentum bietet."
      >
      </Infotext>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, inject } from "vue";
import IconSprite from "@/components/IconSprite.vue";
import Infotext from "@/components/Infotext.vue";
import { useFormStore } from "@/businesslogic/stores/formStore";

export default defineComponent({
  name: "HugRabatt",
  components: {
    IconSprite,
    Infotext,
  },
  setup() {
    const piniaStore = useFormStore();
    const isMakler = piniaStore.state.isMakler;
    const toggleSichtbarkeit = inject("wechsleSichtbarkeit");

    return {
      isMakler,
      toggleSichtbarkeit,
      piniaStore,
    };
  },
});
</script>

<style scoped></style>
